import { App } from 'antd';
import Icon from '../../cpn/Icon';
import {  useFeiyongDelMutation } from '../../store/DianShangYeWuApi';   
function ExpenseDel(props) {
    const {modal,message} = App.useApp(); 
    const [submitDel] = useFeiyongDelMutation()  
    return (
        <Icon type='delete'  onClick={() => {
            if (!props.fy_id) {
                message.error('缺少必要的ID参数');
                return;
            }
            modal.confirm({
                title: '点击确定删除费用单',
                content: '删除后不能恢复！',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    submitDel({
                        fy_id:props.fy_id+'',
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.info('删除成功！');
                        }
                        if (res.data.Status === "fail") {
                            message.error('删除失败！'+res.data.Message)
                        }
                    })
                },
                onCancel() {
                    // console.log('Cancel');
                },
            }); 
        }}/>
    )
}

export default ExpenseDel